export const SINGLE_1_LAYOUT = {
    id: 'single-1',
    family: 'single',
    cards: 1,
    description: 'Carta singola centrata, pensata per draw rapidi e mobile-first.',
    supports_focus_overlay: false,
    variants: [
        {
            id: 'portrait',
            points: [{ x: 50, y: 50, z: 1 }],
        },
        {
            id: 'compact',
            points: [{ x: 50, y: 54, z: 1 }],
        },
        {
            id: 'wide',
            points: [{ x: 50, y: 48, z: 1 }],
        },
    ],
};
//# sourceMappingURL=single-1.js.map